module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "applicationTitle"
  }, [_c('span', {
    staticClass: "spanTitle uppercase"
  }, [_vm._v(_vm._s(_vm.getTranslate(_vm.app.terms.name)))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 col-sm-offset-1"
  }, [_c('p', {
    staticClass: "allSelectTitle uppercase"
  }, [_vm._v(_vm._s(_vm.$t("common.selectAll")) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 d-flex justify-content-around"
  }, [_vm._l((_vm.getRolesComplete), function(role) {
    return _c('ClientColorButton', {
      key: role.id,
      attrs: {
        "size": 's'
      },
      on: {
        "click": function($event) {
          _vm.applyRoleForFunctionalities(role);
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.getTranslate(role.terms.name)))])
  }), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "size": 's'
    },
    on: {
      "click": function($event) {
        _vm.applyRoleForFunctionalities({
          id: null
        });
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("userrole.none")))])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.app.functionalities), function(funct, index) {
    return _c('FunctionalitySection', {
      key: index,
      attrs: {
        "listRoles": _vm.getRolesComplete,
        "funct": funct,
        "currentRole": _vm.getAccessObject(funct)
      },
      on: {
        "updateRole": _vm.changeRole
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cc18c6e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/user/AppSection.vue
// module id = 3055
// module chunks = 0